import { sum } from "lodash";

import { ProductRequestItemInput } from "services/types/products-requests.type";
import { normalizeFloatingNumberCorrection } from "./common";

export const formatProductWithActualPrice = (
  item: ProductRequestItemInput,
  actual_price: string = "0"
): ProductRequestItemInput => {
  const actualPrice = parseFloat(actual_price ?? "0");
  return { ...item, price: actualPrice };
};

const convertToNumbers = (
  originalProductPricesStrings: string[],
  currentTotalPriceString: string
) => {
  return {
    currentTotalPrice: parseFloat(currentTotalPriceString ?? "0") || 0,
    originalProductPrices: originalProductPricesStrings.map(
      (price) => parseFloat(price ?? "0") || 0
    ),
  };
};

const addValueToFirstProductPrice = (
  productPrices: number[],
  value: number
) => {
  productPrices[0] = normalizeFloatingNumberCorrection(
    productPrices[0] + value
  );
};

export const recalculateProductsPricesWithDistribution = (
  originalProductPricesStrings: string[],
  currentTotalPriceString: string
) => {
  if (!originalProductPricesStrings?.length) return [];

  const { currentTotalPrice, originalProductPrices } = convertToNumbers(
    originalProductPricesStrings,
    currentTotalPriceString
  );

  const originalTotalPrice = normalizeFloatingNumberCorrection(
    sum(originalProductPrices)
  );

  const productsPricePercentage = originalProductPrices.map(
    (price) => price / originalTotalPrice
  );

  const recalculatedActualProductPrices = originalProductPrices.map(
    (price, index) =>
      normalizeFloatingNumberCorrection(
        currentTotalPrice * productsPricePercentage[index]
      )
  );

  const calculatedNewPrices = normalizeFloatingNumberCorrection(
    sum(recalculatedActualProductPrices)
  );
  const missingRoundedValue = normalizeFloatingNumberCorrection(
    currentTotalPrice - calculatedNewPrices
  );

  addValueToFirstProductPrice(
    recalculatedActualProductPrices,
    missingRoundedValue
  );

  return recalculatedActualProductPrices.map((price) =>
    isNaN(price) || price < 0 ? 0 : price
  );
};
